import { Injectable } from '@angular/core';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';
import { isNullOrUndefined } from 'util';

@Injectable()
export class DespachoFecharService {

  apiService: any;

  constructor() { }

  fechar(vm, dados) {
    dados.data_andamento = vm.dataHoraDoSistema;

    if (dados.tipoFechamento == '') {
      vm.toastr.warning('O Campo Tipo fechamento não pode ser vazio. Cadastro não finalizado!', 'Atenção');
      return false

    } else {

      return true;
    }
  }
}


// WEBPACK FOOTER //
// ./src/app/services/despachoFechar.service.ts